/**
 * FileReferenceData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { FileReference } from './file_reference'

/**
 * FileReferenceData
 */
export interface FileReferenceData {
  /** 引用基础信息 */
  info?: FileReference
  referer_info?: any
}

/**
 * FileReferenceData Schema
 */
export const FileReferenceDataSchema: SchemaDefinition = {
  properties: {
    info: {
      $ref: 'FileReference',
      description: '引用基础信息',
      label: '引用基础信息',
    },
    referer_info: { type: 'any', description: '' },
  },
  type: 'object',
}
